import React from 'react';
const printerImage = 'https://cdn.magicpatterns.com/patterns/generated-images/267cffad-11f8-489d-9c0a-7b576d79602c.jpg';
const steps = [{
  title: 'Choisissez votre modèle',
  text: 'Parcourez les modèles du pack et sélectionnez celui qui vous inspire.'
}, {
  title: 'Imprimez-le',
  text: 'Imprimez-le à la taille souhaitée, sur une simple feuille de papier.'
}, {
  title: 'Tracez et peignez',
  text: 'Placez le modèle sous votre support transparent, suivez les contours au cerne, puis ajoutez les couleurs.'
}, {
  title: 'Laissez sécher, puis exposez',
  text: 'Respectez le temps de séchage indiqué par le fabricant de vos produits avant de décorer votre intérieur ou d’offrir votre pièce.'
}];
export function HowItWorks() {
  return <section aria-labelledby="how-title" className="on-dark bg-teal text-ivory px-5 sm:px-8 py-16 sm:py-24" data-id="element-112" data-mp="gs0anhs6li46">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 lg:grid-rows-[auto_1fr] gap-x-16 gap-y-10" data-id="element-113" data-mp="14h1f6txw8946">
        <div className="lg:col-start-2 lg:row-start-1" data-id="element-114" data-mp="19byyqussu0vb">
          <h2 id="how-title" className="font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold" data-id="element-115" data-mp="2rmpkmempwxvf">
            Pas besoin de dessiner vos modèles
          </h2>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-ivory/85 max-w-lg" data-id="element-116" data-mp="31b7j2p7iysvw">
            Imprimez le motif de votre choix, placez-le sous un support transparent
            adapté et suivez les contours.
          </p>
        </div>

        <figure className="lg:col-start-1 lg:row-start-1 lg:row-span-2" data-id="element-117" data-mp="3aaksjhvnfhgm">
          <div className="aspect-[4/5] overflow-hidden rounded-[2rem] ring-1 ring-gold/40" data-id="element-118" data-mp="36bbz6e4itlll">
            <img src={printerImage} alt="Imprimante posée sur une table en bois, imprimant un modèle de fleur au trait, à côté d’autres modèles imprimés et d’un support transparent" loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-119" data-mp="3kalg5g0jwjqm" />
          </div>
          <figcaption className="mt-4 text-center text-xs font-semibold tracking-[0.08em] sm:tracking-[0.18em] text-ivory/80" data-id="element-120" data-mp="1kx7kpiobvbar">
            TÉLÉCHARGEZ · IMPRIMEZ · CRÉEZ
          </figcaption>
        </figure>

        <ol className="lg:col-start-2 lg:row-start-2 self-start" data-id="element-121" data-mp="3pya9d22adavg">
          {steps.map((step, i) => <li key={step.title} className="relative grid grid-cols-[2.75rem_1fr] gap-x-4 pb-8 last:pb-0" data-id="element-122" data-mp="3u05bg8s1jsaa" data-mpi={i}>
              {i < steps.length - 1 && <span aria-hidden="true" className="absolute left-[1.375rem] top-12 bottom-1 w-px bg-ivory/25" data-id="element-123" data-mp="2u43wa7abgte" />}
              <span className="flex h-11 w-11 items-center justify-center rounded-full border border-ivory/35 font-serif text-lg font-semibold text-coral-light" data-id="element-124" data-mp="7s5ox0o9tq7i">
                {i + 1}
              </span>
              <div className="pt-1.5" data-id="element-125" data-mp="hk1qwmtha0h0">
                <h3 className="font-serif text-xl font-semibold" data-id="element-126" data-mp="lkc5gnvc5z7h">{step.title}</h3>
                <p className="mt-1.5 text-base leading-relaxed text-ivory/80" data-id="element-127" data-mp="lmg5uvu10g30">{step.text}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}